import { useEffect, useState } from "react";
import { Outlet, Navigate, useLocation  } from "react-router-dom";
import UpgradeYourPlan from "../StatusPages/UpgradeyourPlan";
import Loader from "../components/HomePage/Loader";

const PrivateRoutes = ({ allowedRoles }) => {
  // Initialize auth as false, assuming the user is not authenticated initially
  const [isAuthenticated, setAuthenticated] = useState();
  const [userRoles, setUserRoles] = useState([]);
  const [loading, setLoading] = useState(true);
  const location = useLocation(); // current URL


  useEffect(() => {
    fetch("/api/check-auth")
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        }
        throw new Error("Authentication check failed");
      })
      .then((data) => {
        setUserRoles(data.roles || []); // Ensure data.roles is an array or default to an empty array
        setAuthenticated(data.success);
      })
      .catch((error) => {
        console.error("Error checking authentication:", error);
        setAuthenticated(false);
      });
  }, []);
  useEffect(() => {
    // Show loader immediately on route change
    setLoading(true);

    // Hide loader after a short delay (fast feel)
    const timer = setTimeout(() => setLoading(false), 800); // 80ms works well

    return () => clearTimeout(timer);
  }, [location.pathname]);

  // Use checkAuthentication to determine whether to render Outlet or navigate to /login
  if (isAuthenticated === undefined) return null; // or loading indicator, etc...

  if (!isAuthenticated) {
    // Redirect to login if the user is not authenticated
    return <Navigate to="/login" />;
  }

  // Check for required roles only if the user is authenticated
  const hasRequiredRoles = allowedRoles.includes(userRoles);
  console.log("Allowed Roles :", allowedRoles);
  console.log("Required Roles:", hasRequiredRoles);
  console.log("User Role:", userRoles)

  if (!hasRequiredRoles) {
    // Redirect to unauthorized page if the user doesn't have the required roles
    if (allowedRoles.includes(1) && allowedRoles.includes(2)) {
      // Redirect to dashboard if user has roles 1 or 2
      return <Navigate to="/dashboard" />;
    } else {
      // Redirect to upgrade plan page for other users
      return <UpgradeYourPlan role={userRoles} />;
    }
  }

  return (
    <>
      <Outlet />        {/* Render your page */}
      {loading && <Loader />}  {/* Overlay loader on top */}
    </>
  );
};

export default PrivateRoutes;
